import { render, staticRenderFns } from "./OfficeShowPage.vue?vue&type=template&id=50c0046d&"
import script from "./OfficeShowPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeShowPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports